"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const graphql_1 = require("../..");
exports.emails = graphql_tag_1.default `
  query emails(
    $skip: Int,
    $take: Int,
    $orderBy: String,
    $assignedEmails: Boolean
  ) {
    emailsCount(
      assignedEmails: $assignedEmails
    )
    emails(
      skip: $skip,
      take: $take,
      orderBy: $orderBy,
      orderDir: "DESC",
      assignedEmails: $assignedEmails
    ) {
      id
      createdAt
      updatedAt
      name
      emailNumber
      resourceUrl
      resourceEndpoint
      assignedUsers {
        ...basicUserDetailData
      }
      creatingUser {
        ...basicUserDetailData
      }
      emailTemplateVersion {
        id
        version
        createdAt
        template {
          id
          name
          productionVersion {
            id
            createdAt
            version
            screenshot {
              id
              url
            }
          }
          stagingVersion {
            id
            createdAt
            version
            screenshot {
              id
              url
            }
          }
        }
      }
    }
  }
  ${graphql_1.basicUserDetailData}
`;
exports.email = (includeDefaultContentFeedInEmailQuery = true) => graphql_tag_1.default `
  query email(
    $emailNumber: Int!,
    $useNewLoaderFeature: Boolean
  ) {
    email(
      emailNumber: $emailNumber,
      useNewLoaderFeature: $useNewLoaderFeature
    ) {
      ...emailDetailData
    }
  }
  ${graphql_1.emailDetailData(includeDefaultContentFeedInEmailQuery)}
`;
//# sourceMappingURL=emails.js.map